import React, { Fragment, useEffect, useState } from 'react'
import { Card, Col, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import styled, { css } from 'styled-components'
import callApi from '../../helpers/callapi'
import CONSTANTS from '../../constants/constants'
import Colors from '../../constants/Colors'
import moment from 'moment'
import ConfigModal from './ConfigModal'
import { useDispatch } from 'react-redux'
import axios from 'axios'
import configs from '../../config'
import Cookies from 'js-cookie'
import { setWebConfig } from '../../reducers/webconfig/webConfigSlice'
import { getRounds } from '../../services/config-services'
import { useSelector } from 'react-redux'

const ButtonCard = styled.a``
const LiCustom = styled.li``

const CONFIGS = CONSTANTS.config
const PROGRAMMER_PERMISSIONS = 'programmer-permissions'

const Configs = () => {
  const permissions = useSelector((state) => state.admin.permissions)
  const [fullPage, setFullPage] = useState(false)
  const [contents, setContents] = useState([])
  const [searchText, setSearchText] = useState('')
  const [configModalVisible, setConfigModalVisible] = useState(false)
  const [selectedConfig, setSelectedConfig] = useState({})
  const [type, setType] = useState('all')
  const [rounds, setRounds] = useState([])
  const [dates, setDates] = useState([])
  const [dateBuy, setBuyLotteries] = useState([])
  const [me, setME] = useState([])
  const dispatch = useDispatch()

  let dateInData = []

  const fetchContents = async (page, _searchText = searchText, _type = type) => {
    try {
      dispatch({ type: 'loading_show' })
      const res = await axios.get(`${configs.apiAdminGateway}/api/v1/admin/configs`, {
        headers: { authorization: `Bearer ${Cookies.get('accessToken')}` },
      })
      dispatch(setWebConfig(res.data.data))

      let newContents = CONFIGS.map((item) => {
        let value = res.data.data[item.value]
        if (item.value === 'roundCloseImage') {
          value = res.data.data['images']['round-close']
        } else if (item.value === 'roundCloseDetail') {
          return {
            name: 'roundCloseDetail',
            label: 'ตั้งค่าการปิดรอบ',
            flex: true,
            value: {
              title: res.data.data['roundCloseDetail']['title'],
              descriptions: res.data.data['roundCloseDetail']['descriptions'],
              images: res.data.data['images'],
              type: res.data.data['roundCloseType'],
              isSchedule: false,
              openTime: res.data.data['nextRound'],
            },
          }
        }
        else if (item.value === 'prizesShareCampaign') {
          return {
            name: 'prizesShareCampaign',
            label: 'โชคดีมีไว้แชร์',
            flex: true,
            value: {
              currentRound: res.data.data['roundDate'],
              isRoundClosed: res.data.data['isRoundClosed'],
            },
          }
        }

        return { ...item, name: item.value, value }
      })

      const isProgrammer = permissions.includes(PROGRAMMER_PERMISSIONS)

      if (!isProgrammer) {
        newContents = newContents.filter((item) => item.name !== 'noFee' && item.name !== 'limitPreOrder')
      }

      setContents(newContents)
      dispatch({ type: 'loading_hide' })
    } catch (error) {
      console.log('error configs', error)
      dispatch({ type: 'loading_hide' })
    }
  }

  const fetchAllRounds = async () => {
    const data = await getRounds()
    setRounds(data.map((r) => ({ roundDate: r.value })))
  }

  const fetchMe = async () => {
    try {
      const me = await callApi({
        url: '/admins/me',
      })
      setME(me)
    } catch (error) {
      console.log('error', error)
    }
  }
  useEffect(() => {
    fetchMe()
  }, [])

  const setDatesString = () => {
    const period = Array(30)
      .fill(1)
      .map((_, i) => moment().add(i, 'day').format('DD-MM-YY'))
    period.unshift('none')
    setDates(period)
  }
  const setDatesBuyLotteries = () => {
    const periods = Array(30)
      .fill(1)
      .map((_, i) => moment().startOf('month').add(i, 'day').add(543, 'year').format('DD-MM-YY'))
    periods.unshift('none')
    setBuyLotteries(periods)
  }

  dates.forEach((element) => {
    if (element !== 'none') {
      dateInData.push({ value: element, label: element })
    }
  })

  const columns = [
    {
      key: 'createdAt',
      title: 'ชื่อ',
    },
    {
      key: 'description',
      title: 'value',
    },
  ]

  const render = (data) => {
    const { value, name } = data
    if (name === 'showResult') {
      if (value === true) {
        return 'แสดงรางวัล'
      } else {
        return 'ไม่แสดงรางวัล'
      }
    }
    if (name === 'isRoundClosed') {
      if (value === true) {
        return 'ปิดรอบ'
      } else {
        return 'เปิดรอบซื้อขาย'
      }
    }
    if (name === 'roundCloseDetail' || name === 'prizesShareCampaign') {
      return 'ตั้งค่า'
    }
    if (name === 'showBox') {
      if (value === true || value === 'true') {
        return 'เปิด'
      } else {
        return 'ปิด'
      }
    }
    if (
      name === 'isEnabledPoint' ||
      name === 'isEnabledPreOrder' ||
      name === 'isEnabledAffiliate' ||
      name === 'isEnableQRcode' ||
      name === 'isEnableSlip' ||
      name === 'isEnableNokshop' || 
      name === 'allowCharity'
    ) {
      if (value === true || value === 'true') {
        return 'เปิด'
      } else {
        return 'ปิด'
      }
    }
    if (name === 'emptyImage' || name === 'roundCloseImage' || name === 'noFee') {
      return ''
    }
    return `${value}`
  }
  useEffect(() => {
    fetchContents()
    fetchAllRounds()
    setDatesString()
    setDatesBuyLotteries()
  }, [])

  return (
    <Fragment>
      <Row>
        <Col sm={fullPage ? 12 : 6} lg={fullPage ? 12 : 6} md={fullPage ? 12 : 6} xl={fullPage ? 12 : 6}>
          <Card className={fullPage ? 'bg-warning' : 'bg-warning '}>
            <Row>
              <Col>
                <div>
                  <Card.Header>
                    <Card.Title> Configs</Card.Title>
                    {fullPage ? (
                      <span
                        onClick={() => setFullPage(false)}
                        className="badge"
                        style={{
                          borderRadius: '5rem',
                          backgroundColor: '#000',
                          color: 'white',
                          cursor: 'pointer',
                        }}
                      >
                        X
                      </span>
                    ) : (
                      <span className="badge" style={{ borderRadius: '5rem', backgroundColor: 'red', color: 'white' }}>
                        {contents.length}
                      </span>
                    )}
                  </Card.Header>
                  <Row>
                    <Col
                      md={selectedConfig.name === 'noFee' ? 6 : fullPage ? 6 : 12}
                      lg={selectedConfig.name === 'noFee' ? 6 : fullPage ? 6 : 12}
                    >
                      <div className="card-body" style={{ background: 'white' }}>
                        <Card className="mb-3">
                          <ul className="timeline">
                            <LiCustom className="p-1">
                              <div className="timeline-panel">
                                <div className="media-body list-group-item d-flex justify-content-between">
                                  {columns.map((item, index) => (
                                    <span className="mb-2" key={index}>
                                      {item.title}
                                    </span>
                                  ))}
                                </div>
                              </div>
                            </LiCustom>
                            {contents.map((item, index) => (
                              <ButtonCard
                                style={{ cursor: 'pointer' }}
                                key={index}
                                onClick={() => {
                                  setFullPage(true)
                                  setSelectedConfig(item)
                                }}
                              >
                                <LiCustom className="p-1">
                                  <div className="timeline-panel">
                                    <div
                                      className={`media-body list-group-item ${
                                        item.flex ? 'd-flex' : ''
                                      } justify-content-between`}
                                    >
                                      <div className="mb-2 ">
                                        {item.label}{' '}
                                        {item.label === 'เวลาหมดอายุการโอน' && (
                                          <span className="text-red">(ห้ามปรับ)</span>
                                        )}
                                      </div>
                                      <div className="mb-2 text-muted">{render(item)}</div>
                                    </div>
                                  </div>
                                </LiCustom>
                              </ButtonCard>
                            ))}
                          </ul>
                        </Card>
                      </div>
                    </Col>
                    {fullPage && (
                      <Col>
                        <div
                          className="card-body"
                          style={{
                            height: ['emptyImage', 'roundCloseImage'].includes(selectedConfig.name) ? '80%' : 'auto',
                            overflow: 'hidden',
                          }}
                        >
                          <ConfigModal
                            // loading={loading}
                            selectedConfig={selectedConfig}
                            setIsVisible={setConfigModalVisible}
                            isVisible={configModalVisible}
                            onClose={() => fetchContents(1)}
                            rounds={rounds}
                            dates={dates}
                            dateBuy={dateBuy}
                            dateInData={dateInData}
                            me={me}
                            fetchContents={fetchContents}
                          ></ConfigModal>
                        </div>
                      </Col>
                    )}
                  </Row>
                </div>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </Fragment>
  )
}

export default Configs

const Menu = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 15px;
`
const LinkName = styled(Link)`
  flex: 1;
  padding: 20px 0;
  text-align: center;
  font-size: 20px;
  cursor: pointer;
  &:hover {
    font-weight: bold;
    color: ${Colors.WHITE};
    background-color: ${Colors.BLUE};
  }
  ${({ actived }) =>
    actived &&
    css`
      font-weight: bold;
      color: ${Colors.WHITE};
      background-color: ${Colors.BLUE};
    `};
  border: 1px solid ${Colors.BLUE};
`
